export default __webpack_public_path__ + "static/media/logo-delfsland.c44ad14e.svg";